import React, { useState } from "react";
import "./LoginAndRegister.css";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { OpenLoginSignUp, ResetLoginSignUp } from "../../Actions/ToggleSignupA";
import { GetLocalStorage } from "../../Helpers/LocalStorage/LocalStorage";
import UserSigning from "./Components/UserSigning/UserSigning";
import InstituteNewSide from "./Components/InstituteSide/InstituteNewSide";

let TopLoginRegisterBtns = `absolute border-none   rounded-t-[28px]  cursor-pointer Boldfont hidden md:inline-block 
            -top-9   lg:-top-11 xl:-top-14 2xl:-top-16
            py-[6px] lg:py-2 xl:py-3 2xl:py-4
            px-20    lg:px-24 xl:px-28 2xl:px-32 
            text-2xs lg:text-xs xl:text-base 2xl:text-[30px]`;

const SignUp = () => {
    const { error, loading, UserInfo } = useSelector(
        (Store) => Store.LoginSignupReducer
    );
    const { AuthPageName, Navigation, Done } = useSelector(
        (Store) => Store.ToggleSignupReducer
    );
    const { userType } = useSelector((Store) => Store.ToggleSignupReducer); // Get userType from Redux state

    const Navigate = useNavigate();
    const Dispatch = useDispatch();
    const [ScreenSize, setScreenSize] = useState();

    useEffect(() => {
        window.addEventListener("resize", () => {
            setScreenSize(Number(window.innerWidth));
        });
    }, []);

    useEffect(() => {
        if (Object.keys(error).length === 0 && Done && Navigation) {
            Dispatch(ResetLoginSignUp(false));
            // Keep enrollment-continuation redirect; students otherwise go to enrolled courses
            if (GetLocalStorage("navigateToEnroll")) {
                return;
            }
            if (UserInfo?.User === "Student") {
                Navigate("/mycourses/enrolledcourses");
            } else {
                Navigate("/");
            }
        } else if (Object.keys(error).length === 0 && Done && !Navigation)
            Dispatch(ResetLoginSignUp(false));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Navigate, error, Done, Navigation, UserInfo]);

    return AuthPageName ? (
        <div
            // className="LightBg"
            className={`LightBg ${userType === "Partner" ? "partner-bg" : ""}`} // Conditional class
            style={{
                backgroundImage: userType === "Partner" ? "url('/assets/partnerbg.png')" : "none",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
            // onClick={(e) => {
            //     Dispatch(OpenLoginSignUp(false, false));
            // }}
        >
            <div
                className="MainParent bgGradient"
                onClick={(e) => e.stopPropagation()}
            >
                {/* {!loading
                        ? <div className="ImageContainer">
                            <div className='w-full h-80 bg-[#000000cc] ' > </div>
                        </div>
                        : null
                    } */}
                <div
                    className="FormParent bg-transparent md:bg-transparent"
                    style={{ backgroundColor: "transparent" }}
                >
                    {AuthPageName === "Register" ? (
                        <>
                            <InstituteNewSide />  
                            {/* <InstituteSide />   */}
                        </>
                    ) : (
                        <UserSigning
                            ScreenSize={ScreenSize}
                            TopLoginRegisterBtns={TopLoginRegisterBtns}
                        />
                    )}
                </div>
            </div>
        </div>
    ) : null;
};

export function SubmitButton({ AuthPageName, type, OnClickFun, otpVerified }) {
    const isDisabled = AuthPageName === "Sign In" && !otpVerified;

    return (
        <span
            className={`submit-btn-box-shadow relative  flex w-full max-w-[575px]  justify-center ${
                AuthPageName === "Sign In" ? "mt-[70px]" : "mt-16"
            }`}
        >
            <img
                className="xl-top-[-62px] pointer-events-none absolute   top-[-61px] left-[60%]  w-[103px]  -translate-x-1/2 md:top-[-62px]  lg:top-[-62px] lg:w-[103px] xl:w-[103px]"
                src={require("./Assets/Sign up Avater.png")}
                alt=""
            />
            <button
                className={`w-full cursor-pointer rounded-[8px] border-none bg-primary  py-2
                           text-[16px] text-white  xl:py-2 
                            xl:text-[18px]     2xl:text-base ${
                    isDisabled ? "cursor-not-allowed" : ""
                        }`}
                type={type}
                disabled={isDisabled}
                onClick={OnClickFun}
            >
                {/* {AuthPageName === "Sign In" ? "Create an account" : AuthPageName} */}
                 {AuthPageName} 
            </button>
        </span>
    );
}

export default SignUp;
